import { FC } from 'react';

import { isMainBankAccountType } from 'common/bankAccount/utils';

import { useCompanyBankAccounts } from '../../../../../common/hooks/useCompanyBankAccounts';
import { useBankOverviewSearchParams } from '../hooks/useBankOverviewSearchParams';
import { MainBankAccountEmptyState } from './components/MainBankAccountEmptyState';
import { SecondaryBankAccountEmptyState } from './components/SecondaryBankAccountEmptyState';

const BankEmptyState: FC = () => {
  const { bankAccounts } = useCompanyBankAccounts();
  const { bankAccountId } = useBankOverviewSearchParams();

  const currentBankAccount = bankAccounts.find(
    (bankAccount) => bankAccount.bankAccountId === bankAccountId,
  );
  const isMainBankAccount = currentBankAccount
    ? isMainBankAccountType(currentBankAccount.type)
    : false;

  return isMainBankAccount ? (
    <MainBankAccountEmptyState bankAccountId={bankAccountId} />
  ) : (
    <SecondaryBankAccountEmptyState bankAccountId={bankAccountId} />
  );
};

export default BankEmptyState;
